export const TERMS_OF_USE = 'https://libertasfunding.com/terms-and-conditions/';
export const PRIVACY_POLICY = 'https://libertasfunding.com/privacy-policy/';
export const CA_PRIVACY_NOTICE = 'https://libertasfunding.com/california-privacy-notice/';
